export const percentage = (val: number, fix = 2) => (val * 100).toFixed(fix);
